import { GET_ACADEMIC_YEARS, GET_BATCHES, GET_BRANCHES, GET_GRADES, GET_NLEARN3_BATCHES, GET_NLEARN3_BRANCHES, GET_NLEARN3_CLASSES, GET_NLEARN3_SECTIONS, GET_NLEARN3_STREAMS, GET_PROJECTS_LIST, GET_SECTIONS, GET_STREAMS, GET_VENDOR_ACCOUNTS, GET_VENDORS } from "utils/graphql/services/live-classes/queries";
import authClientService from "utils/graphql/authClient";
import * as Yup from "yup";

export type nl3LiveclassPackagesFilter = {
  batchId: string;
  gradeId: string;
  branchId: string;
  sectionId: string;
  academicYearId: number;
  streamId: string;
  projectIds: string;
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const nl3LiveclassPackagesInitialValues: nl3LiveclassPackagesFilter = {

  batchId: "",
  gradeId: "",
  branchId: "",
  sectionId: "",
  academicYearId: 0,
  streamId: "",
  projectIds:"",
  created_at: [null, null],
  updated_at: [null, null],
};

export const nl3LiveclassPackagesMandatoryFields = [];

export const nl3LiveclassPackagesValidationSchema = Yup.object().shape({
  created_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  updated_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
});

export const nl3LiveclassPackagesProperties = [

  {
    id:"academicYearId",
    type:"single-select-search",
    label:"Academic Year",
    keyValue: {label: "name", value: "id"},
    query: GET_ACADEMIC_YEARS,
    client: authClientService,
    gqlKey: "getAcademicYears",
    dataKey: "academicYears",
    // extraPayload: { isArchived: false },
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "branchId",
    type: "single-select-search",
    label: "College",
    keyValue: { label: "name", value: "id" },
    query: GET_BRANCHES,
    client: authClientService,
    gqlKey: "getBranches",
    dataKey: "branches",
    // extraPayload: { isArchived: false },
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "gradeId",
    type: "single-select-search",
    label: "Class",
    keyValue: { label: "name", value: "id" },
    query: GET_GRADES,
    client: authClientService,
    gqlKey: "getGrades",
    dataKey: "grades",
    // extraPayload: { isArchived: false },
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  // {
  //   id: "classId",
  //   type: "single-select-search",
  //   label: "Class",
  //   keyValue: { label: "name", value: "objectId" },
  //   query: GET_NLEARN3_CLASSES,
  //   gqlKey: "getNlearn3Classes",
  //   dataKey: "nlearn3Classes",
  //   // extraPayload: { isArchived: false },
  //   searchFieldKey: "searchName",
  //   breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
  //   required: true,
  // },

  {
    id: "streamId",
    type: "single-select-search",
    label: "Stream",
    keyValue: { label: "name", value: "id" },
    query: GET_STREAMS,
    client: authClientService,
    gqlKey: "getStreams",
    dataKey: "streams",
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  // {
  //   id: "batchId",
  //   type: "single-select-search",
  //   label: "Batch",
  //   keyValue: { label: "name", value: "objectId" },
  //   query: GET_NLEARN3_BATCHES,
  //   gqlKey: "getNlearn3Batches",
  //   dataKey: "nlearn3Batches",
  //   extraPayload: { isArchived: false },
  //   searchFieldKey: "searchName",
  //   breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    
  //   required: true,
  // },
   {
    id: "batchId",
    type: "single-select-search",
    label: "Batch",
    keyValue: { label: "name", value: "id" },
    query: GET_BATCHES,
    client: authClientService,
    gqlKey: "getBatches",
    dataKey: "batches",
    // extraPayload: { isArchived: false },
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    
    required: true,
  },

  {
    id:"sectionId",
    type:"single-select-search",
    label:"Section",
    keyValue: { label: "name", value: "id" },
    query: GET_SECTIONS,
    client: authClientService,
    gqlKey: "getSections",
    dataKey: "sections",
    searchFieldKey: "searchName",
    // dependentOn: ["gradeId"],
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "projectIds",
    type: "multi-select-search",
    label: "Project",
    keyValue: { label: "name", value: "id" },
    query: GET_PROJECTS_LIST,
    gqlKey: "getProjects",
    dataKey: "projects",
    searchFieldKey: "searchName",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    Placeholder: "Select Created Date Range",
    className: "created-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    Placeholder: "Select Updated Date Range",
    className: "updated-date-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
